<template>

    <div>

        <transition name="modal">
            <v-modal-subscription-create v-if="showModal === 'create'"
                :plan="selectedPlan"
                :amount="amount * (selectedPlan.interval === 'month' ? 1 : 12)"
                :quantity="quantity"
                @changed="$emit('changed')">
            </v-modal-subscription-create>
        </transition>

        <v-page-section padded>
            <template #title>Select a Plan</template>
            <template #body>
                <div class="plans">
                    <div class="plans-header">
                        <v-switch class="mr-10" @input="switchInterval" />
                        <span>Save 20% with annual billing</span>
                    </div>
                    <div class="plans-body">
                        <div class="slider">
                            <div class="slider-title">
                                <span>{{ amountForQuantity(sliderQuantity) / 100 | numeral('$0,0') }} / month</span><br>
                                <span>{{ sliderQuantity | numeral('0,0') }} customers</span><br>
                            </div>
                            <v-slider class="mb-50"
                                v-model="sliderQuantity"
                                :adsorb="true"
                                :duration=".3"
                                :height="10"
                                :marks="marks"
                                :tooltip="'none'"
                                :data="[500,1000,5000,10000,25000,50000,100000]">
                            </v-slider>
                            <v-button class="m-auto" @click.native="selectPlan(volumePlan, sliderQuantity)" btn-rounded>Upgrade</v-button>
                        </div>
                    </div>
                </div>
            </template>
        </v-page-section>

    </div>

</template>

<style scoped lang="scss">

    .plans {
        background: #fff;
        border: 1px solid $color-rule;
        border-radius: 5px;
        overflow: hidden;
        .plans-header {
            @include font-medium(11px);
            align-items: center;
            border-bottom: 1px solid $color-rule;
            display: flex;
            font-size: 12px;
            padding: 20px;
        }
        .plans-body {
            padding: 40px 60px;
        }
    }

    .slider {
        padding: 0;
        text-align: center;
        .slider-title {
            @include font-medium(18px);
            display: block;
            line-height: 1.4em;
            margin-bottom: 15px;
            .small {
                @include font-medium(12px);
                color: $color-muted;
            }
        }
        .slider-caption {
            @include font-medium(13px);
            color: $color-muted;
            margin-top: 40px;
        }
    }

</style>

<script>

import ModalSubscriptionCreate from '@modals/subscription/ModalSubscriptionCreate';
import numeral from 'numeral';
import VueSlider from 'vue-slider-component';

export default {

    components: {
        'v-modal-subscription-create': ModalSubscriptionCreate,
        'v-slider': VueSlider,
    },

    props: {
        plans: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            selectedPlan: null,
            interval: 'month',
            quantity: 0,
            sliderQuantity: 500,
            marks: val => ({ label: numeral(val).format('0a') }),
        }
    },

    computed: {

        company() {
            return this.$store.getters.company;
        },

        packagePlans() {
            return this.plans.filter(p => {
                return p.interval === this.interval && p.billing_scheme === 'per_unit';
            }).sort(function(a, b) {
                return a.amount - b.amount;
            });
        },

        volumePlan() {
            let plans = this.plans.filter(p => {
                return p.interval === this.interval && p.billing_scheme === 'tiered';
            });
            return plans[0];
        },

        amount() {
            return this.amountForQuantity(this.quantity);
        },

    },

    methods: {

        amountForQuantity(quantity) {
            let tiers = this.volumePlan.tiers;
            let amount = null;

            // Get price from tier.
            for (let tier of tiers) {
                if (quantity <= tier.up_to) {
                    amount = (tier.unit_amount_decimal * quantity) + tier.flat_amount;
                    break;
                }
            };

            // Use last tier?
            if (!amount) {
                let tier = tiers[tiers.length - 1];
                amount = (tier.unit_amount_decimal * quantity) + tier.flat_amount;
            }

            return this.interval === 'month' ? amount : amount / 12;
        },

        selectPlan(plan, quantity = 1) {
            this.selectedPlan = plan;
            this.quantity = quantity;
            this.$store.commit('showModal', 'create');
        },

        switchInterval(e) {
            let annual = e.target.checked;
            this.interval = (annual ? 'year' : 'month');
        },

    },

}

</script>